import { useState, useEffect } from 'react';
import './seat_map_user.css'; // CSS 파일 import
import { get_testing_accept_list, get_testing_place_schedule_list } from '../../utils/restapi';
import TESTING_ACCEPT_STATUS from '../../constants/testing_accept';

const TestingPrintSeatMapUser = ({ testingPlaceObj, testingScheduleObj, direction, onClose }) => {
  // 목록
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [testingPlaceSchedules, setTestingPlaceSchedules] = useState([]);
  const [directionState, setDirectionState] = useState(direction || 'vertical');

  // 고사실별로 데이터 그룹화하는 함수
  const groupByRoom = (items) => {
    const grouped = {};
    items.forEach(item => {
      const roomNo = item.room_no || '미배정';
      if (!grouped[roomNo]) {
        grouped[roomNo] = [];
      }
      grouped[roomNo].push(item);
    });
    return grouped;
  };

  console.log("testingPlaceObj:", testingPlaceObj);

  // 가져온 그룹을 좌석 배치에 따라 정렬하는 함수
  const sortBySeatArrangement = (roomItems, direction) => {
    const rows = testingPlaceObj.data?.seat?.rows || 0;
    const cols = testingPlaceObj.data?.seat?.columns || 0;
    console.log("rows:", rows, "cols:", cols, "direction:", direction);

    return roomItems.sort((a, b) => {
      const seatA = parseInt(a.seat_no) || 0;
      const seatB = parseInt(b.seat_no) || 0;
      return direction === 'vertical' ? seatA - seatB : seatB - seatA;
    });
  };

  // 방향 전환 핸들러
  const handleDirection = () => {
    setDirectionState(prev => prev === 'vertical' ? 'horizontal' : 'vertical');
  };

  // 프린트 함수 - 간단하게 window.print() 사용
  const handlePrint = () => {
    const htmls = document.querySelectorAll('#testing_print_seat_map_user .body');
    htmls.forEach(html => {
      const newWin = window.open('', 'Print-Window');
      newWin.document.open();
      newWin.document.write(`
        <html>
          <head>
            <title>Print</title>
            <style>
              @page { size: A4; margin: 0; }
              /* 인쇄 시 글자색(빨강/파랑 제목)이 누락되지 않도록 강제 (원본 PHP 와 동일) */
              * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
              #testing_print_seat_map_user { font-family: Arial, sans-serif; }

              #testing_print_seat_map_user .body { margin: 0; padding: 0; }

              /* 한 페이지에 한 고사실 — A4 고정 크기, 매 .page 마다 분할 */
              #testing_print_seat_map_user .page {
                width: 210mm;
                height: 297mm;
                box-sizing: border-box;
                overflow: hidden;
                padding: 1.2cm;
                text-align: center;
                page-break-after: always;
                break-after: page;
              }
              #testing_print_seat_map_user .page:last-child { page-break-after: auto; break-after: auto; }

              /* 칠판 위치 안내 (부착용은 위쪽) */
              #testing_print_seat_map_user .board-note {
                font-size: 16pt;
                line-height: 50px;
                margin-bottom: 25px;
              }

              /* 첫 번째 테이블 (제목 정보) */
              #testing_print_seat_map_user .page > table:nth-of-type(1) {
                width: auto;
                border-collapse: collapse;
                margin: 5px auto 25px auto;
              }

              #testing_print_seat_map_user .page > table:nth-of-type(1) td {
                text-align: center;
                vertical-align: middle;
                padding: 5px 15px;
                white-space: nowrap;
              }

              #testing_print_seat_map_user .page > table:nth-of-type(1) td:nth-child(1) {
                font-size: 16pt;
                font-weight: bold;
              }

              #testing_print_seat_map_user .page > table:nth-of-type(1) td:nth-child(2) {
                color: blue;
                font-size: 18pt;
                font-weight: bold;
                white-space: nowrap;
              }

              #testing_print_seat_map_user .page > table:nth-of-type(1) td:nth-child(2) b {
                color: red;
                font-size: 30px;
              }

              #testing_print_seat_map_user .page > table:nth-of-type(1) td:nth-child(3) {
                font-size: 16pt;
                font-weight: bold;
                white-space: nowrap;
              }

              /* 좌석 격자 — 각 tr = 물리적 열, 각 td = 좌석칸(3줄: 아이디/이름/수험번호) */
              #testing_print_seat_map_user .page > table.seat-grid {
                width: 100%;
                border-collapse: collapse;
                table-layout: fixed;
              }
              #testing_print_seat_map_user .page > table.seat-grid td {
                text-align: center;
                vertical-align: middle;
                overflow: hidden;
              }
              #testing_print_seat_map_user .page > table.seat-grid ul {
                display: block;
                list-style: none;
                margin: 0 auto;
                padding: 0;
                width: 100%;
                max-width: 150px;
                box-sizing: border-box;
              }
              #testing_print_seat_map_user .page > table.seat-grid ul li {
                border: 2px solid #000;
                text-align: center;
              }
              #testing_print_seat_map_user .page > table.seat-grid ul li + li { border-top: none; }

              /* 인쇄 시 head, foot 숨김 */
              #testing_print_seat_map_user .head, #testing_print_seat_map_user .foot { display: none !important; }
            </style>
          </head>
          <body>
            <div id="testing_print_seat_map_user">
              <div class="body">
                ${html.innerHTML}
              </div>
            </div>
          </body>
        </html>
      `);
      newWin.document.close();
      newWin.print();
      setTimeout(() => { newWin.close(); }, 10);
    });
  };

  const getTestingPlaceSchedule = async () => {
    if (!testingPlaceObj || !testingScheduleObj) return;

    try {
      const response = await get_testing_place_schedule_list({
        testing_place_id: testingPlaceObj.testing_place_id,
        testing_schedule_id: testingScheduleObj.testing_schedule_id,
        page: 1,
        rowsPerPage: 1000,
      });
      console.log("getTestingPlaceSchedule response:", response);
      setTestingPlaceSchedules(response.lists || []);
    } catch (error) {
      console.error("Error fetching testing place schedule:", error);
      setTestingPlaceSchedules([]);
    }
  };

  // 리스트 가져오기 — 한 번에 큰 rowsPerPage로 조회하면 일정 인원 이상에서
  // 누락되는 사례가 있어, 페이지 단위로 나눠 조회한 뒤 이어붙인다.
  const handleGetData = async () => {
    const PAGE_SIZE = 100;
    const MAX_PAGES = 50; // 안전장치: 최대 5,000명까지 (무한 루프 방지)

    const baseJson = {
      testing_place_id: testingPlaceObj?.testing_place_id || 0,
      testing_schedule_id: testingScheduleObj?.testing_schedule_id || 0,
      // 고사장은 여러 지역본부 학생이 함께 배정되므로, 지역본부(hcodes)로 제한하지 않고
      // 이 고사장·일정에 배정된 응시자를 전부 가져온다.
      isAllocation: 1,
      // 접수신청(join) 단계에서도 고사실/좌석이 먼저 배정되는 경우(단체·오프라인 접수 등)가 있어,
      // decided 이상이 아니라 취소/환불/삭제대기 등을 제외한 "유효한" 상태 전체(used)로 조회한다.
      status: TESTING_ACCEPT_STATUS.used.join(','),
      sort: 'a_room_no*1, a_seat_no*1, a_code*1',
      desc: 'asc',
      rowsPerPage: PAGE_SIZE,
    };

    try {
      let combined = [];
      for (let page = 1; page <= MAX_PAGES; page++) {
        const response = await get_testing_accept_list({ ...baseJson, page });
        const list = response.lists || [];
        combined = combined.concat(list);

        const totalPages = parseInt(response.totalPages, 10) || 1;
        if (list.length < PAGE_SIZE || page >= totalPages) break;
      }
      console.log(`handleGetData: fetched ${combined.length} rows`);
      setItems(combined);
    } catch (error) {
      console.error("Error fetching testing places:", error);
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTestingPlaceSchedule();
    handleGetData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 고사실별 그룹화된 데이터
  const roomGroups = groupByRoom(items);

  return (
    <div id="testing_print_seat_map_user">
      <div className="head">
        <h1>좌석배치도(부착용)</h1>
      </div>
      <div className="body">
        {loading ? (
          <div className="notice">로딩중...</div>
        ) : items.length === 0 ? (
          <div className="notice">고사실/좌석 배정이 완료되지 않았습니다.</div>
        ) : sortBySeatArrangement(Object.entries(roomGroups), directionState).map(([roomNo, roomItems], roomIndex) => {
          // roomNo에 해당하는 testingPlaceSchedule 찾기
          const matchedSchedule = testingPlaceSchedules.find(s =>
            s.testing_place_id === testingPlaceObj.testing_place_id &&
            s.testing_schedule_id === testingScheduleObj.testing_schedule_id &&
            s.room_no === roomNo
          );

          // 좌석 정보 추출
          const cols = matchedSchedule?.data?.seat?.columns || 1;
          const rows = matchedSchedule?.data?.seat?.rows || 1;
          const total = cols * rows;

          // roomItems의 갯수와 total이 다를 경우, 모자란 만큼 빈 데이터 추가
          const filledItems = [...roomItems];
          while (filledItems.length < total) {
            filledItems.push({});
          }

          // PHP getListRoomseat 와 동일하게 [열][행] 2차원 격자를 만든다.
          //  - vertical  : 행 우선 채움 (seat k → 열=k%cols, 행=floor(k/cols))
          //  - horizontal : 열 우선 채움 (seat k → 열=floor(k/rows), 행=k%rows)
          const grid = [];
          for (let c = 0; c < cols; c++) {
            const colArr = [];
            for (let r = 0; r < rows; r++) {
              const k = directionState === 'vertical' ? (r * cols + c) : (c * rows + r);
              colArr.push(filledItems[k] || {});
            }
            grid.push(colArr);
          }
          // 부착용: 칠판이 위쪽 → 열 좌→우, 행 위→아래 그대로 출력한다 (뒤집지 않음).
          const displayGrid = grid;

          const visualCols = rows;      // 한 행(tr)의 가로 칸 수 = td 개수
          const verticalRows = cols;    // tr 개수 = 세로 칸 수

          // ── 세로 맞춤: 제목·안내문·상하 여백을 빼고 하단 여유까지 둔 격자 높이 예산에
          //    맞춰 줄높이·패딩을 정한다 → 인쇄 시 아래가 잘리지 않고 하단 공간 확보.
          const GRID_BUDGET_PX = 760;
          const rowBudget = GRID_BUDGET_PX / verticalRows;               // 한 셀(3줄) 높이 예산
          const paddingPx = Math.max(1, Math.min(8, Math.floor((rowBudget - 3 * 16) / 2)));
          const lineHeightPx = Math.max(13, Math.min(40, Math.floor((rowBudget - 2 * paddingPx) / 3)));

          // ── 가로 맞춤: 칸이 많을수록 폰트를 줄인다. 세로 예산 폰트와 함께 더 작은 값 사용.
          const widthFontPt = visualCols <= 5 ? 14 : (visualCols <= 7 ? 13 : (visualCols <= 9 ? 12 : 11));
          const heightFontPt = Math.max(7, Math.min(14, Math.round(lineHeightPx * 0.55)));
          const fontPt = Math.min(widthFontPt, heightFontPt);

          const cellWidth = `${(100 / visualCols).toFixed(3)}%`;
          const ulStyle = { lineHeight: `${lineHeightPx}px`, fontSize: `${fontPt}pt` };

          // 학생 이름 가운데 마스킹: 첫 글자 + '*' + (세 번째 글자부터)  예) 홍길동→홍*동, 김구→김*
          const maskName = (name) => {
            if (!name) return '';
            return name.substring(0, 1) + '*' + (name.length > 2 ? name.substring(2) : '');
          };

          // 제목 3칸(고사장명/고사실/좌석배치도)이 A4 폭을 넘겨 잘리지 않도록,
          // 고사장명 길이에 따라 제목 폰트를 동적으로 줄인다.
          const placeName = testingPlaceObj?.name || '';
          const titlePt = placeName.length <= 12 ? 16 : (placeName.length <= 16 ? 14 : (placeName.length <= 20 ? 12 : 10));
          const roomB = `<b style="color:red;font-size:${Math.round(titlePt * 1.6)}px;">`;
          const roomStr = String(roomNo);
          const roomNoHtml = roomStr.includes('고사실')
            ? roomB + roomStr.replace('고사실', '</b>고사실')
            : roomB + roomStr + '</b>';

          return (
            <div key={roomNo} className="page">
              <div className="board-note">위쪽이 칠판(교탁)쪽 입니다.</div>
              <table>
                <tbody>
                  <tr>
                    <td style={{ fontSize: `${titlePt}pt` }}>{testingPlaceObj.name}</td>
                    <td style={{ fontSize: `${titlePt + 2}pt` }} dangerouslySetInnerHTML={{ __html: roomNoHtml }}></td>
                    <td style={{ fontSize: `${titlePt}pt` }}>좌석배치도</td>
                  </tr>
                </tbody>
              </table>
              <table className="seat-grid">
                <tbody>
                  {displayGrid.map((colCells, i) => (
                    <tr key={i}>
                      {colCells.map((item, j) => (
                        <td key={j} style={{ padding: `${paddingPx}px`, width: cellWidth }}>
                          <ul style={ulStyle}>
                            <li>{item?.userObj?.id ? item.userObj.id.substring(0, 4) + '**' : '\u00A0'}</li>
                            <li>{item?.personObj?.name ? maskName(item.personObj.name) : '\u00A0'}</li>
                            <li>{item?.code || '\u00A0'}</li>
                          </ul>
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          );
        })}
      </div>
      <div className="foot">
        <button onClick={handleDirection}>{ directionState === 'vertical' ? '가로방향' : '세로방향' }</button>
        <button onClick={handlePrint}>인쇄</button>
        <button onClick={() => onClose()}>닫기</button>
      </div>
    </div>
  );
};

export default TestingPrintSeatMapUser;